var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getCityListApiInWeb, getHotCityListApi } from '../api/City';
export const getCityList = () => __awaiter(void 0, void 0, void 0, function* () {
    const cities = yield getCityListApiInWeb();
    const alphabetCitiesMap = cities.reduce((map, city) => {
        var _a;
        const firstAlphabet = ((_a = city.pinyin) === null || _a === void 0 ? void 0 : _a.trim()[0].toUpperCase()) || '';
        map[firstAlphabet] = map[firstAlphabet] || [];
        map[firstAlphabet].push(city);
        return map;
    }, {});
    return Object.keys(alphabetCitiesMap).map(key => {
        return {
            label: key,
            showAll: false,
            data: alphabetCitiesMap[key]
        };
    }).sort((a, b) => a.label.charCodeAt(0) - b.label.charCodeAt(0));
});
export const getHotCityList = () => {
    return getHotCityListApi();
};
